module.exports = __webpack_public_path__ + "static/media/smartphones3.73cf11f3.png";